var map = {
	"./3983529.png": "ee2b",
	"./Biologia II.png": "91ef",
	"./Biologia.png": "632a",
	"./Ciencias Sociales.png": "b0d2",
	"./Dibujo.png": "9b8d",
	"./Etica II.png": "3684",
	"./Etica.png": "ffc6",
	"./Fisica II.png": "dd0d",
	"./Fisica.png": "783b",
	"./Hechos.png": "9e44",
	"./Historia II.png": "cffc",
	"./Historia.png": "5f1a",
	"./Informatica II.png": "8db1",
	"./Informatica.png": "1ae2",
	"./Ingles II.png": "3834",
	"./Ingles III.png": "2b83",
	"./Ingles IV.png": "5e86",
	"./Ingles.png": "b65a",
	"./Lectura II.png": "c7d8",
	"./Lectura.png": "c412",
	"./Leyes.png": "bd9e",
	"./Literatura II.png": "32ea",
	"./Literatura.png": "09c8",
	"./Matematicas II.png": "c798",
	"./Matematicas III.png": "fcd9",
	"./Matematicas IV.png": "eacf",
	"./Matematicas.png": "4e94",
	"./Metodo.png": "cc75",
	"./Ninguna.png": "6257",
	"./Orientacion II.png": "96fb",
	"./Orientacion.png": "c8aa",
	"./Quimica II.png": "a40e",
	"./Quimica.png": "34de"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1358";